import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./MobilePayment.module.css";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import loadable from "@loadable/component";
import useIsWorkingTime from "@hooks/useIsWorkingTime";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
var fallback = {
  fallback: "loading..."
};
var MobilePaymentPopup = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "MobilePaymentPopup";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "MobilePaymentPopup" */"./MobilePaymentPopup");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./MobilePaymentPopup");
    }
    return eval('require.resolve')("./MobilePaymentPopup");
  }
}, fallback);
var LeadButtons = function LeadButtons() {
  var is_working_time = useIsWorkingTime();
  var _usePostDetails = usePostDetails(),
    actions = _usePostDetails.actions,
    uiHelpers = _usePostDetails.uiHelpers,
    helpers = _usePostDetails.helpers,
    state = _usePostDetails.state;
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper,
    id: "mobile-payment-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.buttonsContainer, helpers.isCarReserved() && stl.columnDisp].join(" "),
    id: "mobile-payment-buttons"
  }, /*#__PURE__*/React.createElement("span", {
    //onClick={}
    className: "greenTextBtn"
  }, helpers.isCarReserved() ? /*#__PURE__*/React.createElement("strong", {
    onClick: actions.showContactNumbers
  }, t("تواصل مع مندوب المبيعات", {
    ns: "web_post_view"
  })) : !state.showContactNumbers && /*#__PURE__*/React.createElement("span", {
    id: "mobile-call-button",
    onClick: function onClick() {
      is_working_time ? actions.showContactNumbers() : actions.showOutSideWorkingHoursForm();
    }
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    className: "m-show ".concat(stl.callGreen),
    src: CDN_LINK + "/assets/images/CallGreen.svg",
    alt: "call",
    width: 18,
    height: 18
  }), t("اتصل بنا للحجز", {
    ns: "web_post_view"
  }))), helpers.isCarReserved() ? /*#__PURE__*/React.createElement("div", {
    className: stl.reservedCarBox,
    id: "mobile-reserved-notice"
  }, /*#__PURE__*/React.createElement("strong", null, t("هذه السيارة محجوزة", {
    ns: "web_post_view"
  }))) : /*#__PURE__*/React.createElement("a", {
    id: "BuyNowMobile",
    onClick: actions.navigateToLeadPage,
    className: "greenBtn text-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center w-full"
  }, uiHelpers.getCTAGreenButtonText()))));
};
var MobilePayment = function MobilePayment() {
  var _usePostDetails2 = usePostDetails(),
    state = _usePostDetails2.state;
  var is_show_popup = state.showContactNumbers || state.showOutSideWorkingHoursForm;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !is_show_popup && /*#__PURE__*/React.createElement(LeadButtons, null), is_show_popup && /*#__PURE__*/React.createElement(MobilePaymentPopup, null));
};
export default MobilePayment;